import { POSTS_QUERIES } from 'graphql/posts'
import type { PostsQueriesData, PostsQueriesName, PostsQueriesVariables } from 'graphql/posts/types'
import { buildQueryHook } from 'lib/apollo-client/builders'

export const usePostsQueries = buildQueryHook<PostsQueriesName, PostsQueriesVariables, PostsQueriesData>(POSTS_QUERIES)
